import { createFileRoute, Navigate } from '@tanstack/react-router';
import React from 'react';

import { isGameplayHistoryReplayEnabled } from '~/app/config';
import { ROUTE_404 } from '~/app/routes';
import GamesPage from '~/pages/games/index';

export const Route = createFileRoute('/games/')({
  component: GamesRoute,
});

function GamesRoute() {
  if (!isGameplayHistoryReplayEnabled) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <GamesPage />;
}
